import { createUseStyles } from 'react-jss';

var styles = {
  name: {
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 700
    },
    letterSpacing: '0.03rem',
    margin: 0,
    display: 'inline-flex',
    alignItems: 'flex-start',
    maxWidth: '100%',
    width: '100%'
  },
  portfolioName: {
    font: {
      size: '2rem',
      lineHeight: '3rem',
      weight: 700
    },
    maxWidth: '85%'
  },
  checkedIcon: {
    flexBasis: '3.2rem',
    flexShrink: 0,
    marginLeft: '1.5rem'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map